import { Link } from '@spotify-internal/encore-web';
import { withPageImpression } from '@spotify/plugin-confidence-tracking-react';

import {
  TransitionScreen,
  transitionActionLinkClassNames,
} from '../TransitionScreen';

const InviteRequiredPageComponent = () => {
  return (
    <TransitionScreen
      title="Confidence is invite-only"
      description={
        <span>
          Confidence is currently available by invitation only. Contact us to
          learn more about how Confidence can help you experiment like Spotify.
        </span>
      }
      actions={
        <Link
          href="mailto:confidence@spotify.com"
          className={transitionActionLinkClassNames.primary}
        >
          Contact us
        </Link>
      }
    />
  );
};

export const InviteRequiredPage = withPageImpression(
  InviteRequiredPageComponent,
  { pageId: 'invite-required' },
);
